module.exports = __webpack_public_path__ + "static/media/icon_cloud_manage.012e35d0.svg";